import { selectIsLoggedIn } from 'src/common/state/me/me-selectors';

export const shouldRenderSidebar = selectIsLoggedIn;
